import { errorPreventiveCacheRead } from '@sketch/modules-common'
import {
  GetScimPersonalAccessTokensDocument,
  GetScimPersonalAccessTokensQuery,
  GetScimPersonalAccessTokensQueryVariables,
} from '@sketch/gql-types'
import { ClientOrCache } from '@sketch/graphql-cache'

type Me = GetScimPersonalAccessTokensQuery['me']

const get = (cache: ClientOrCache): Me | undefined => {
  return errorPreventiveCacheRead<
    GetScimPersonalAccessTokensQuery,
    GetScimPersonalAccessTokensQueryVariables
  >(cache, { query: GetScimPersonalAccessTokensDocument, variables: {} })?.me
}

const set = (cache: ClientOrCache, me: Me): void => {
  cache.writeQuery<
    GetScimPersonalAccessTokensQuery,
    GetScimPersonalAccessTokensQueryVariables
  >({
    query: GetScimPersonalAccessTokensDocument,
    data: { __typename: 'RootQueryType', me },
  })
}

export { get, set }
